import { render, staticRenderFns } from "./salary-newbuild-header.vue?vue&type=template&id=617b0e94&scoped=true&"
import script from "./salary-newbuild-header.vue?vue&type=script&lang=js&"
export * from "./salary-newbuild-header.vue?vue&type=script&lang=js&"
import style0 from "./salary-newbuild-header.vue?vue&type=style&index=0&id=617b0e94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b0e94",
  null
  
)

export default component.exports